import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class FeeColumnFilterPanelService {
  private subject = new Subject<boolean>();

  constructor() { }

  /**
   * Set toogle fee table column filter Panel.
   *
   * @param flag
   */
  setToggleFilterColumnsPanel(flag: boolean) {
    this.subject.next(flag);
  }

  /**
   * Get toogle fee table column filter Panel.
   */
  getToggleFilterColumnsPanel(): Observable<boolean> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fee-column-filter-panel.service.ts